const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/LabeledDivider.tsx';
import React from 'react';

import { Theme, useTheme } from '@mui/material/styles';
import { css, cx } from '@emotion/css';
import Divider from '@mui/material/Divider';
import { TextInput, useText } from '@cistec/common_web/utils/intlUtils';

export const useCSSClasses = (theme: Theme) => ({
    dividerCss: css`
        & hr {
            position: relative;
            top: 10px;
        }

        & .dividerText {
            position: relative;
            left: 10px;
            display: inline-block;
            padding: 0 4px;
            background-color: ${theme.palette.background.paper};
            color: ${theme.palette.grey['600']};
        }
    `,
});

interface Props {
    text: TextInput;
    className?: string;
}

export function LabeledDivider(props: Props) {
    const text = useText(props.text);
    const theme = useTheme();
    const { dividerCss } = useCSSClasses(theme);
    return (
        <div className={cx(dividerCss, props.className)}>
            <Divider />
            {text && <div className={'dividerText'}>{text}</div>}
        </div>
    );
}
